import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { UserSelector } from 'src/app/shared/store/user/user.feature';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RedirectCommand,
  Router,
} from '@angular/router';
import { ROUTES } from 'src/app/app.routes.constants';
import { PAGES_CONFIG } from 'src/app/shared/page/page.config';

export interface UserIsEditorGuardConfig {
  checkOnlyIfQueryParamsPresent?: string[];
}

export function userIsEditorGuard(
  config?: UserIsEditorGuardConfig,
): CanActivateFn {
  return (route: ActivatedRouteSnapshot) => {
    const store = inject(Store);
    const router = inject(Router);
    const checkOnlyIfEditQueryParamsPresent =
      !!config?.checkOnlyIfQueryParamsPresent;
    const editQueryParams = config?.checkOnlyIfQueryParamsPresent || [];
    const noEditQueryParams = editQueryParams.every(
      param => !route.queryParamMap.has(param),
    );
    const defaultPageUrl =
      PAGES_CONFIG.find(({ pageName }) => pageName === ROUTES.defaultPage)
        ?.defaultUrl ?? '';
    const fallbackPath = router.parseUrl(defaultPageUrl);
    const redirectToFallback = new RedirectCommand(fallbackPath);
    const isEditor$ = store.select(UserSelector.selectIsEditor);
    return isEditor$.pipe(
      map(
        isEditor =>
          isEditor ||
          (checkOnlyIfEditQueryParamsPresent && noEditQueryParams) ||
          redirectToFallback,
      ),
    );
  };
}
